import { gql } from "urql";
export const CreateInsuranceMutation = gql `
    mutation CreateInsurance($name: String!) {
        insurances {
            createInsurance(name: $name) {
                insuranceId
                name
                isActive
            }
        }
    }
`;
export const UpdateInsuranceMutation = gql `
    mutation UpdateInsurance(
        $insuranceId: String!
        $name: String
        $isActive: Boolean
    ) {
        insurances {
            updateInsurance(
                insuranceId: $insuranceId
                name: $name
                isActive: $isActive
            ) {
                insuranceId
                name
                isActive
            }
        }
    }
`;
export const DeleteInsuranceMutation = gql `
    mutation DeleteInsurance($insuranceId: String!) {
        insurances {
            deleteInsurance(insuranceId: $insuranceId) {
                insuranceId
            }
        }
    }
`;
